import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ADVOCATES_PSF_END_REDIRECT = createFcmDetails('advocates_psf_end_redirect', {
	owner: 'Narwhal Squad',
	context: 'Advocates PSF',
	description: 'URL for the end redirect of the Advocates PSF flow',
	import: false,
});
